<template>
    <b-container class="m-3">
        <b-row>
            <b-col>
                <p class="h4">
                    <strong>Location & Hours</strong>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-row class="py-2">
                    <b-col>
                        <b-img width="315px" height="150px" src="https://i.imgur.com/boUPoEq.png"></b-img>
                    </b-col>
                </b-row>
                <b-row class="py-2">
                    <b-col>
                        {{address}}
                    </b-col>
                    <b-col>
                        <b-button variant="outline-primary">Get directions</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <b-col>
                <b-row>
                    <b-container class="text-nowrap font-weight-bold">
                        <b-row class="p-1">
                            <b-col cols="2">Mon</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Tue</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Wed</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col class="text-danger">Closed Now</b-col>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Thu</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Fri</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Sat</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                        <b-row class="p-1">
                            <b-col cols="2">Sun</b-col>
                            <b-col>11:00 AM - 10:00 PM</b-col>
                            <b-col/>
                        </b-row>
                    </b-container>
                    
                </b-row>
                <b-row>
                    <b-button variant="link">
                        <b-icon icon="pencil" aria-hidden="true"></b-icon> Edit business info
                    </b-button>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<style scoped>

</style>

<script>
export default {
    data() {
        return {

        }
    },
    computed: {
        place: {
            get() {
                return this.$store.state.place_current_data
            }
        },
        address: {
            get() {
                var addrStr = ''
                if (this.place.locationAddress1 != '') {
                    addrStr = addrStr + this.place.locationAddress1 + ', '
                }
                if (this.place.locationAddress2 != '') {
                    addrStr = addrStr + this.place.locationAddress2 + ', \n'
                }
                if (this.place.locationAddress3 != '') {
                    addrStr = addrStr + this.place.locationAddress3 + ', '
                }
                if (this.place.locationCity != '') {
                    addrStr = addrStr + '\n' + this.place.locationCity + ', '
                }
                if (this.place.locationZip != '') {
                    addrStr = addrStr + this.place.locationZip + ', '
                }
                addrStr = addrStr + 'Philippines'

                return addrStr
            }
        }
    }
}
</script>